import { httpsCallable } from 'firebase/functions';
import { projectFunctions } from '../firebase/config';

const useAI = () => {

    const generateAICardsForDeck = async ({prompt}) => {
        const f = httpsCallable(projectFunctions, "generateAICardsForDeck");//cloud function
        try {
            let r = await f({prompt: prompt});
            console.log("r: ", r);
            return r["data"];
        } catch (error) {
            console.log("error: ", error);
            return null;
        }
    }

    const generateMultilingualDeckAudio = async ({deckId}) => {
        const f = httpsCallable(projectFunctions, "generateMultilingualDeckAudio");
        try {
            let r = await f({deckId: deckId});
            console.log("Audio generation result: ", r);
            return r["data"];
        } catch (error) {
            console.log("error generating audio: ", error);
            throw error;
        }
    }

    const proofreadMultilingualCard = async ({card, languages, deckTitle, allCardTranslations, deckContext}) => {
        const f = httpsCallable(projectFunctions, "proofreadMultilingualCard");
        try {
            let r = await f({
                card: card, 
                languages: languages,
                deckTitle: deckTitle || "",
                allCardTranslations: allCardTranslations || {},
                deckContext: deckContext || ""
            });
            console.log("Proofreading result: ", r);
            return r["data"];
        } catch (error) {
            console.log("error proofreading card: ", error);
            return [];
        }
    }

    const suggestDeckContextPrompt = async ({deckTitle, sampleCards}) => {
        const f = httpsCallable(projectFunctions, "suggestDeckContextPrompt");
        try {
            let r = await f({
                deckTitle: deckTitle || "",
                sampleCards: sampleCards || []
            });
            return r["data"];
        } catch (error) {
            console.log("error suggesting prompt: ", error);
            return null;
        }
    }

    const checkMultilingualDeckAudioNeeds = async ({deckId}) => {
        const f = httpsCallable(projectFunctions, "checkMultilingualDeckAudioNeeds");
        try {
            let r = await f({deckId: deckId});
            return r["data"];
        } catch (error) {
            console.log("error checking audio needs: ", error);
            throw error;
        }
    }

    const regenerateMultilingualDeckAudioForCards = async ({deckId, cardDocIds}) => {
        const f = httpsCallable(projectFunctions, "regenerateMultilingualDeckAudioForCards");
        try {
            let r = await f({deckId: deckId, cardDocIds: cardDocIds});
            return r["data"];
        } catch (error) {
            console.log("error regenerating audio: ", error);
            throw error;
        }
    }

    return {
        generateAICardsForDeck,
        generateMultilingualDeckAudio,
        proofreadMultilingualCard,
        suggestDeckContextPrompt,
        checkMultilingualDeckAudioNeeds,
        regenerateMultilingualDeckAudioForCards
    }
}

export default useAI;